import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import SEO from '../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO
      title="CPA & Accounting Services in Roslyn, NY"
      description="Lawrence Hoffman, CPA, PC is a family-owned accounting firm in Roslyn, NY serving the tri-state area. Tax preparation, financial planning, and bookkeeping services."
      pathname="/"
    />

    {/* Hero Section */}
    <div className="hero-section">
      <h1>Your Trusted CPA Firm in the Tri-State Area</h1>
      <p className="hero-subtitle">
        For over 40 years, Lawrence Hoffman, CPA, PC has been the trusted choice
        for individuals and businesses throughout the tri-state area. As a
        family-owned firm, we deliver big-firm expertise with the personal
        attention you deserve.
      </p>
      <div className="hero-cta">
        <Link to="/contact/" className="btn btn-primary">
          Schedule a Free Consultation
        </Link>
        <a href="tel:+15166259051" className="btn btn-secondary">
          Call (516) 625-9051
        </a>
      </div>
    </div>

    {/* Value Proposition */}
    <section className="value-prop">
      <h2>Why Choose Lawrence Hoffman, CPA?</h2>
      <p>
        As a family-owned accounting firm, we treat every client like family.
        You get all the expertise of a large firm with the personalized
        attention only a dedicated team can provide. No call centers, no
        runaround—just direct access to experienced CPAs who know your
        situation.
      </p>
    </section>

    {/* Services Grid */}
    <section className="services-section">
      <h2>Our Services</h2>
      <div className="services-grid">
        <div className="service-card">
          <h3>Tax Preparation</h3>
          <ul>
            <li>Personal Income Tax Returns</li>
            <li>Corporation Tax Returns</li>
            <li>Fiduciary Tax Returns</li>
            <li>Estate Tax Returns</li>
            <li>Retirement Plan Returns</li>
          </ul>
        </div>
        <div className="service-card">
          <h3>Financial Statements</h3>
          <ul>
            <li>Financial Statement Preparation</li>
            <li>Cash Flow Analysis</li>
            <li>Profit & Loss Statements</li>
            <li>Balance Sheet Preparation</li>
          </ul>
        </div>
        <div className="service-card">
          <h3>Business Services</h3>
          <ul>
            <li>Bookkeeping & Write-Up</li>
            <li>Bank Reconciliations</li>
            <li>Payroll Tax Returns</li>
            <li>QuickBooks ProAdvisor Services</li>
          </ul>
        </div>
        <div className="service-card">
          <h3>Planning Services</h3>
          <ul>
            <li>Financial Planning</li>
            <li>Tax Planning</li>
            <li>Estate Planning</li>
            <li>Retirement Planning</li>
          </ul>
        </div>
      </div>
    </section>

    {/* About Section */}
    <section className="about-section">
      <h2>About Our Firm</h2>
      <p>
        Allen Hoffman, CPA is the second generation owner of Lawrence Hoffman,
        CPA, P.C. which is a full-service public accounting firm located in
        Roslyn, New York, proudly serving clients throughout New York, New
        Jersey, and Connecticut. With decades of experience, we've helped
        countless individuals and businesses navigate complex financial
        challenges while building lasting relationships based on trust and
        results.
      </p>
      <p>
        In addition to traditional accounting services, we offer{' '}
        <Link to="/computer-consulting/">computer consulting services</Link>{' '}
        through our affiliate, Lawall Service Corp., providing complete IT
        solutions. As a QuickBooks ProAdvisor, we offer expert QuickBooks setup,
        training, and support.
      </p>
    </section>

    {/* Trust Indicators */}
    <section className="trust-section">
      <h2>Serving the Community Since 1982</h2>
      <div className="trust-grid">
        <div className="trust-item">
          <span className="trust-number">40+</span>
          <span className="trust-label">Years of Experience</span>
        </div>
        <div className="trust-item">
          <span className="trust-number">3</span>
          <span className="trust-label">States Served</span>
        </div>
        <div className="trust-item">
          <span className="trust-number">100%</span>
          <span className="trust-label">Personalized Service</span>
        </div>
      </div>
    </section>

    {/* CTA Section */}
    <section className="cta-section">
      <h2>Ready to Get Started?</h2>
      <p>
        Contact us today for a free consultation. We'll discuss your needs and
        show you how our personalized approach can make a difference.
      </p>
      <Link to="/contact/" className="btn btn-primary">
        Contact Us Today
      </Link>
    </section>
  </Layout>
)

export default IndexPage
